import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { updateMessages } from "./messagesAPI";
import swal from 'sweetalert';
export interface MessageState {
  updatemessages: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: MessageState = {
  updatemessages: [],
  status: "idle",
};

export const UpdateMessages = createAsyncThunk(
  "message/updateMessages",
  async (data:any) => {
    const response = await updateMessages(data);
    return response;
  }
);

export const updateMessageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(UpdateMessages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(UpdateMessages.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(UpdateMessages.fulfilled, (state, action) => {
        state.status = "idle";
        state.updatemessages =  action.payload;
        swal("Record updated success!",  "success");
      });
  },
});

export const {} = updateMessageSlice.actions;

export const selectUpdatedMessages = (state: RootState) => {
  return state.Updatemessage.updatemessages;
};

export default updateMessageSlice.reducer;
